import { Component, Input, ContentChild, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-form-section',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="form-section" [class.logo-section]="isLogoSection">
      <h2 *ngIf="title">{{ title }}</h2>
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./form-section.component.scss']
})
export class FormSectionComponent {
  @Input() title: string = '';
  @Input() isLogoSection: boolean = false;
} 